// フォーム関連

document.addEventListener('DOMContentLoaded', function() {

	// 購入数UI
	if (document.querySelector('.js-order-number')) {
		document.querySelectorAll('.js-order-number').forEach(ui => {
			try {
				
				if (ui.querySelector('.js-order-number-minus')) {
					// ui.querySelector('.js-order-number-minus', '.js-order-number-plus').addEventListener('click', updateNumber, false)
					ui.querySelector('.js-order-number-minus').addEventListener('click', updateNumber, false)
				}
				if (ui.querySelector('.js-order-number-plus')) {
					// ui.querySelector('.js-order-number-minus', '.js-order-number-plus').addEventListener('click', updateNumber, false)
					ui.querySelector('.js-order-number-plus').addEventListener('click', updateNumber, false)
				}

			} catch(err) {
				console.error(err);
			}

			
		})
		function updateNumber(e) {
			if (e) {
				e.preventDefault();
				e.stopPropagation();
			}

			const input = e.target.closest('.js-order-number').querySelector('.js-order-number-input');
			if (!input) {
				throw new Error('購入数inputがありません');
			}
			const number = !isNaN(Number(input.value)) ? Number(input.value) : 0;
			const formInput = input.closest('.js-cart') ? input.closest('.js-cart').querySelector('input[name="product_num"]') : null;
			if (!formInput) {
				throw new Error('埋め込みフォームの購入数inputがありません');
			}

			if (e.target.classList.contains('js-order-number-minus')) {
				if (number >= 2) {
					input.value = number - 1;
					formInput.value = number - 1;
				} else {
					input.value = 1;
					formInput.value = 1;
				}
				
			} else if (e.target.classList.contains('js-order-number-plus')) {
				input.value = number + 1;
				formInput.value = number + 1;
			} else {
				input.value = 1;
				formInput.value = 1;
			}
			
		}
	}

	// カートに入れる
	if (document.querySelector('.js-cart .js-cart-button')) {
		document.querySelectorAll('.js-cart .js-cart-button').forEach(button => {
			button.addEventListener('click', function(e) {
				try {
					
					e.preventDefault();
					e.stopPropagation();
					const form = e.target.closest('.js-cart').querySelector('form[name="product_form"]');
					if (!form) {
						throw new Error('カートJSで埋め込まれるフォームがありません');
					}
					form.target = '_blank';
					form.submit();
				} catch (err) {
					console.error(err);
				}
			}, false)
		})
	}

})